import React from 'react';
import '../../sass/preloader.scss';

export const PreLoaderSmall = ({ className }) => {
    return <div className={`preloader-small ${className}`} />;
};
